import { render, staticRenderFns } from "./UATPayment.vue?vue&type=template&id=26d2f906&scoped=true&"
import script from "./UATPayment.vue?vue&type=script&lang=js&"
export * from "./UATPayment.vue?vue&type=script&lang=js&"
import style0 from "./UATPayment.vue?vue&type=style&index=0&id=26d2f906&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d2f906",
  null
  
)

export default component.exports